<tidy-row class="bookable-row">
  <span class="bookable square"></span>
  <tidy-text [body]="labelOn"></tidy-text>
  <span class="notbookable square"></span>
  <tidy-text [body]="labelOff"></tidy-text>
</tidy-row>
